var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.titulo
        ? _c(
            "div",
            { attrs: { align: "left" } },
            [
              _c("h2", [_vm._v("\n      " + _vm._s(_vm.titulo) + "\n      ")]),
              _c("v-divider"),
              _c("br")
            ],
            1
          )
        : _vm._e(),
      _c("v-layout", { attrs: { wrap: "" } }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }